import styled from '@emotion/styled'

export const AdminListItemImageStyle = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50px;
`
